module.exports = __webpack_public_path__ + "img/bookmark.c9b8137d.svg";